import React from 'react'
import { Form } from 'antd'
import moment from 'moment'
import { MomentTimePicker } from '@gravitate-js/excalibrr'

export const TimePickerInput = ({
  editable,
  name,
  message,
  initialValue = '',
  required = false,
  format = 'h:mm A',
  ...others
}) => {
  if (!editable) return initialValue
  return (
    <Form.Item name={name} noStyle rules={[{ required: required, message: { message } }]}>
      <SmartTimePicker use12Hours format={format} initialValue={initialValue} {...others} />
    </Form.Item>
  )
}

const SmartTimePicker = ({ initialValue, format, ...others }) => {
  if (initialValue != null) {
    var momentDate = moment(initialValue, format)
    return <MomentTimePicker defaultValue={momentDate} format={format} {...others} />
  }

  return <MomentTimePicker format={format} {...others} />
}
